import { useCallback, useEffect, useState } from 'react';

import { getRiderBySlug } from '../api/services/Riders';

export const useRiderDetails = (riderSlug) => {
  const [riderDetails, setRiderDetails] = useState<Nullable<RiderDetails>>(null);
  const [isFetching, setIsFetching] = useState(false);

  useEffect(() => {
    if (riderSlug) {
      setIsFetching(true);
      fetchRider();
    }
  }, [riderSlug]);

  const fetchRider = useCallback(async () => {
    const response = await getRiderBySlug(riderSlug);

    if (response?.type === 'success' && response.data.passenger) {
      setRiderDetails(response.data.passenger);
    }
    setIsFetching(false);
  }, []);

  return { riderDetails, isFetching };
};
